import { ReactNode, useMemo, useState } from 'react';

import { tripExtraContext } from './context';
import { TripExtra } from './types';
import { noop } from '../../utils/common';

type Props = {
  children: ReactNode;
  sharedTripToken?: string;
};

export const TripExtraProvider = ({ children, sharedTripToken }: Props) => {
  const [animateCamera, setAnimateCamera] = useState<TripExtra['animateCamera']>(() => noop);

  const value = useMemo(() => ({ animateCamera, setAnimateCamera, sharedTripToken }), [animateCamera, sharedTripToken]);

  return <tripExtraContext.Provider value={value}>{children}</tripExtraContext.Provider>;
};
